import axios, { AxiosInstance } from 'axios';

// Cache of Axios instances by access token
// We only expect one access token per user at a time, but this will keep us from attempting to make any calls with a stale token
const jeanieAxiosClientCache: Record<string, AxiosInstance> = {};

/**
 * Returns an Axios client configured for Jeanie API endpoints
 *
 * Clients are cached by access token to avoid creating new instances
 * unnecessarily while ensuring each token gets its own client
 */
export function getJeanieAxiosClient(accessToken: string): AxiosInstance {
    // Return cached instance if it exists for this token
    if (jeanieAxiosClientCache[accessToken]) {
        return jeanieAxiosClientCache[accessToken];
    }

    // Create a new instance for this token
    const client = axios.create({
        baseURL: process.env.NEXT_PUBLIC_JEANIE_BASE_URL,
        timeout: 30000,
        headers: { AUTHORIZATION: `Bearer ${accessToken}` },
    });

    // Remove other cached client(s)
    for (const token in jeanieAxiosClientCache) {
        if (token !== accessToken) {
            delete jeanieAxiosClientCache[token];
        }
    }

    // Cache the new instance
    jeanieAxiosClientCache[accessToken] = client;

    return client;
}
